import PropTypes from 'prop-types';
import { createComponent } from '../core/create-component.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const propTypes = {
    /**
   * The visual style of the Range
   */ skin: PropTypes.oneOf([
        'standard',
        'hue',
        'saturation',
        'contrast',
        'custom'
    ]),
    /**
   * Should it be unfilled or not? (Note: some skins will always be unfilled.)
   */ unfilled: PropTypes.bool,
    /**
   * When using a skin with a two-color gradient, the start color of the gradient
   */ gradientStartColor: PropTypes.string,
    /**
   * When using a skin with a two-color gradient, the end color of the gradient. "saturation" Ranges also need to specify this value
   */ gradientEndColor: PropTypes.string
};
const Range = createComponent({
    displayName: 'Range',
    root: 'input',
    propTypes,
    propConfig: {
        processProps (_param) {
            var { style = {}, gradientStartColor, gradientEndColor } = _param, props = _object_without_properties(_param, [
                "style",
                "gradientStartColor",
                "gradientEndColor"
            ]);
            return _object_spread_props(_object_spread({}, props), {
                style: _object_spread_props(_object_spread({}, style), {
                    '--swan-range-gradient-start-color': gradientStartColor,
                    '--swan-range-gradient-end-color': gradientEndColor
                })
            });
        },
        classNames (props) {
            const { unfilled = false, skin = 'standard' } = props;
            const classesSet = new Set([
                'swan-range'
            ]);
            if (unfilled) classesSet.add('swan-range-unfilled');
            if (skin !== 'standard') classesSet.add(`swan-range-skin-${skin}`);
            return classesSet;
        }
    }
});
Range.defaultProps = {
    unfilled: false,
    skin: 'standard',
    type: 'range'
};

export { Range };
